import React from "react";
import { Tag, Callout, Icon, Tooltip } from "@blueprintjs/core";

import { mefPlate } from "../../../utils/mef";
import { Trans } from "react-i18next";

export function ALPRSensorStatusTag(props) {
  if (props.state === undefined)
    return null;

  let icon;
  let intent;
  let text = null;
  switch (props.state) {
    case "disconnected":
      icon = "unknown-vehicle"
      intent = "danger";
      text = <Trans>sensor disconnected</Trans>
      break;
    case "idle":
      icon = "unknown-vehicle"; // stay gray
      intent = "primary";
      text = <Trans>sensor running, no vehicle detected</Trans>
      break;
    case "presence":
      if (props.plate === undefined) {
        icon = "vehicle";
        intent = "primary";
        text = <Trans>sensor running, no plate detected</Trans>
      } else {
        icon = "known-vehicle";
        intent = "success";
        text = <Trans>sensor running, detected licence plate:</Trans>
      }
      break;
    default:
      return null;
  }

  return <span><Tag rightIcon={icon} intent={intent}></Tag>{props.displayText && <span> {text}</span>}</span>;
}

export function InfoALPRSensor(props) {
  if (props.state === undefined)
    return null;

  let plate = null;
  let intent;
  switch (props.state.state) {
    case "disconnected":
      intent = "danger"
      break;
    case "idle":
      intent = "success"
      break;
    case "presence":
      intent = "success"
      if (props.state.plate === undefined) {
      } else {
        plate = <span className="licenseplate-little">{props.state.plate}</span>;
      }
      break;
    default:
      return null;
  }

  return (
    <Callout>
      <Callout title={<span><Icon icon="full-circle" intent={intent} /> <Trans>ALPR sensor</Trans></span>}>
        <ALPRSensorStatusTag {...props.state} displayText={true} /> {plate}
      </Callout>
    </Callout>);
}

function ALPRSensorStatusIcon(props) {
  if (props.plate && props.jpeg)
    return <Icon icon="known-vehicle" intent="primary" />;

  if (props.state === "presence" && !props.plate)
    return <Icon icon="unknown-vehicle" intent="primary" />;

  if (props.state === "idle")
    return <Icon icon="tick" intent="primary" />;

  if (props.state === "disconnected")
    return <Icon icon="offline" intent="danger" />;

  return null;
}

function ALPRSensorStatusIntent(props) {
  if (props.state === "presence")
    return "primary";

  if (props.state === "idle")
    return "primary";

  if (props.state === "disconnected")
    return "danger";

  return null;
}

function ALPRSensorImage(props) {
  switch (props.hardware) {
    case "Micropak":
    case "Micropak2":
    case "Micropak3":
      return <img
        src={"/ow/view/pictures/alpr/micropak.webp"}
        alt="Micropak sensor"
        style={{
          maxHeight: "100px", aspectRatio: "auto", width: "auto", height: "auto"
        }}
      />

    case "Nanopak":
    case "Nanopak2":
    case "Nanopak3":
      return <img
        src={"/ow/view/pictures/alpr/nanopak.webp"}
        alt="Nanopak sensor"
        style={{
          maxHeight: "100px", aspectRatio: "auto", width: "auto", height: "auto"
        }}
      />
    default:
      return null;
  }
}

export function ALPRSensor(props) {

  return <Callout title={props.definition.name} icon={ALPRSensorStatusIcon(props.state)} intent={ALPRSensorStatusIntent(props.state)} style={{ marginBottom: "5px" }}>
    <div className="flexbox-center-large">
      <div className="flexbox-left">
        <ALPRSensorImage hardware={props.definition.hardware} />
        <div> {/* definition */}
          <p>{props.definition.hardware} ({props.definition.version})</p>
          <p>{props.definition.ip}:{props.definition.main_port}</p>
        </div>
      </div>

      <div> {/* state */}
        {(props.state.plate && props.state.jpeg) && /* vehicule detected and decision ok */
          <div>
            <Tooltip content={<img alt="alpr detection, context capture" src={props.state.jpeg} style={{
              width: "400px"
            }} />} openOnTargetFocus={false}>
              <figure style={{ // used to crop the plate on the image
                width: (props.state.width + 140) + "px",
                height: (props.state.height + 50) + "px",
                overflow: "hidden", /*hide bounds of image */
                marginLeft: "-25px"
              }}>
                <img src={props.state.jpeg} alt="alpr detection, plate cropped"
                  style={{
                    margin: "-" + (props.state.y - 25) + "px 0px 0px -" + (props.state.x - 70) + "px"
                  }}
                />
              </figure>
            </Tooltip>
            <p><Trans>extracted licence plate:</Trans> <span className="licenseplate" style={{ border: "solid black 1px" }}>{mefPlate(props.state.plate)}</span> ({props.state.reliability}%, <Trans>alpr_read</Trans> {props.state.plate_occurences} <Trans>times</Trans>)</p>

            {/* <p><Trans>direction:</Trans><Trans>{"alprDirection_" + props.state.direction}</Trans></p> */}
            {/* <p>context: {props.state.context}</p> */}
            {/* <p>square_plate: {props.state.square_plate}</p> */}
            {/* <p>constrast: {props.state.constrast}</p> */}
          </div>}

        {(props.state.state === "presence" && !props.state.plate) && <p><Trans>vehicule detected, decoding plate</Trans></p>}

        {(props.state.state === "idle") && <p><Trans>sensor waiting for vehicule detection</Trans></p>}

        {(props.state.state === "disconnected") && <p><Trans>sensor disconnected</Trans></p>}

      </div>
    </div>
    {/* {<Icon icon={props.definition.locked ? "lock" : "unlock"} />} */}
  </Callout >;
}
